import React, { createContext, useState } from "react";

// Create the LayoutContext
export const LayoutContext = createContext();

const LayoutContextProvider = ({ children }) => {
  // State for active sidebar
  const [activeSidebar, setActiveSidebar] = useState("");

  // State for user
  const [user, setUser] = useState(null);

  // Provide the context values to the children components
  return (
    <LayoutContext.Provider
      value={{ activeSidebar, setActiveSidebar, user, setUser }}
    >
      {children}
    </LayoutContext.Provider>
  );
};

export default LayoutContextProvider;
